import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { DurationRange } from "constants/enums";
import { IRoute, IGrouppedPlace, IRouteRequest, IHotelSearchItem } from "types";

type Response = {
  places: IGrouppedPlace[];
};

type HotelsType = { [city: string]: IHotelSearchItem[] };

type InitialState = {
  loading: boolean;
  current?: IRoute;
  response?: Response;
  request: IRouteRequest;
  hotels: HotelsType;
};

const initialRequest: IRouteRequest = {
  prioritizedTags: [],
  avoid: ["MOTORWAY"],
  tags: [],
  roadType: "calm",
  startAsFinish: false,
  buildVariant: "linear",
  duration: { key: "week-off", range: DurationRange["week-off"] },
};

const initialState: InitialState = {
  hotels: {},
  loading: false,
  current: undefined,
  response: undefined,
  request: initialRequest,
};

export const slice = createSlice({
  name: "route",
  initialState: initialState,
  reducers: {
    setRouteLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setRoute: (state, action: PayloadAction<IRoute | undefined>) => {
      state.current = action.payload;
    },
    setRouteResponse: (state, action: PayloadAction<Response | undefined>) => {
      state.response = action.payload;
    },
    setRouteRequest: (state, action: PayloadAction<Partial<IRouteRequest>>) => {
      state.request = { ...state.request, ...action.payload };
    },
    setHotels: (state, action: PayloadAction<HotelsType>) => {
      state.hotels = { ...state.hotels, ...action.payload };
    },
    clearRoute: (state) => {
      state.hotels = {};
      state.loading = false;
      state.current = undefined;
      state.response = undefined;
      state.request = { ...initialRequest };
    },
  },
});

export const {
  reducer,
  actions: {
    setRoute,
    setHotels,
    clearRoute,
    setRouteLoading,
    setRouteRequest,
    setRouteResponse,
  },
} = slice;
